require('vue-play/dist/app.css')
var app = require('vue-play/dist/app').default

app()



//////////////////
// WEBPACK FOOTER
// ./~/vue-play-cli/lib/entries/app.js
// module id = 15
// module chunks = 0